import { ChangeDetectionStrategy, Component, computed, input, model, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonDirective } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
import { FloatLabel } from 'primeng/floatlabel';
import { InputText } from 'primeng/inputtext';
import { Select } from 'primeng/select';

export interface NewTriggerFormValue {
    name: string;
    triggerType: string;
    actionType: string;
}

const EMPTY_FORM: NewTriggerFormValue = {
    name: '',
    triggerType: 'BOOKING_CREATED',
    actionType: 'SEND_EMAIL'
};

@Component({
    selector: 'new-trigger-dialog',
    templateUrl: './new-trigger-dialog.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, TranslatePipe, ButtonDirective, Dialog, FloatLabel, InputText, Select]
})
export class NewTriggerDialogComponent {
    triggerTypeOptions = input<{ label: string; value: string }[]>([]);
    actionTypeOptions = input<{ label: string; value: string }[]>([]);
    creating = input<boolean>(false);

    visible = model<boolean>(false);

    confirmed = output<NewTriggerFormValue>();

    form = signal<NewTriggerFormValue>({ ...EMPTY_FORM });

    isValid = computed(() => !!(this.form().name && this.form().triggerType && this.form().actionType));

    updateForm(patch: Partial<NewTriggerFormValue>): void {
        this.form.update((f) => ({ ...f, ...patch }));
    }

    onHide(): void {
        this.visible.set(false);
    }

    cancel(): void {
        this.visible.set(false);
    }

    confirm(): void {
        if (!this.isValid()) {
            return;
        }
        this.confirmed.emit({ ...this.form() });
    }

    /** Called by parent after a successful creation so the form resets */
    reset(): void {
        this.form.set({ ...EMPTY_FORM });
    }
}
